<!---
    /**
    * File and all contents are proprietary work of Executives On The Web Ltd
    * and must not be copied or redistributed without express permission.
    *
    * Creates an academic year drop down
    *
    * @since 20230216
    * @author Thomas Higham <thomash@executivesontheweb.com>
    *
    * @copyright (c) 2023 Executives On The Web Ltd. All right Reserved.
    */
--->
<template>
    <div>
        <label v-if="!hide_label">{{label}} &nbsp;<tool-tip v-if="tooltip.length > 0" :text="tooltip"></tool-tip></label>
        <select class="form-control form-control" :name="name" :value="academic_year_data" :key="academic_years.length + '_' + academic_year_data" v-on:input="update_academic_year($event)" >
            <option v-if="!hide_default && default_select.length == 0" :value="default_select_value">Select Academic Year</option>
            <option v-else-if="!hide_default" :value="default_select_value">{{default_select}}</option>
            <option v-if="can_pick_dates" value="-1">Pick Dates</option>
            <option v-for="ac in academic_years" :key="ac.id" :value="ac.id">{{ac.name}}</option>
        </select>
    </div>
</template>

<script>
    import loadcomponents from './loadcomponents'
    export default {
        props: {
            //the name of the input
            name: {
                type: String,
                default: 'academic_year'
            },
            //the academic_years
            academic_years: {
                type: Array,
            },
            //the width
            width: {
                default: ''
            },
            //the name of academic_years
            label: {
                type: String,
                default: 'Academic Year'
            },
            //the tooltip
            tooltip: {
                type: String,
                default: ''
            },
            //the defalt value
            value: {
                default: 0
            },
            //the defalt value
            default_select: {
                default: ''
            },
            //the defalt value
            default_select_value: {
                default: 0
            },
            //whether or not to hide the label
            hide_label: {
                default: false
            },
            hide_default: {
                default: false
            },
            user_website_id: {
                type: String,
                default: '0_0'
            },
            can_pick_dates: {
                type: Boolean,
                default: false
            }
        },
        created(){
            this.academic_year_data = this.value;
            if(this.academic_year_data == ''){
                this.academic_year_data = 0;
            }
            this.$searchAcademicYearId = this.academic_year_data;
        },
        data() {
            return {
                academic_year_data: 0,
                academic_years_all: this.academic_years,
                hasLoaded: false,
                loading: false,
                showAll: false
            };
        },
        methods: {
            
            /**
             * updates the model of the editor to the current value
             * @param String value the value of the editor
             */
            update_academic_year: function (value) {
                var newValue = 0;
                if(value.target !== undefined){
                    newValue = value.target.value;
                } else {
                    newValue = value;
                }
                if(newValue == -3){
                    this.showAll = true;
                    newValue = this.academic_year_data;
                } else if(newValue == -2){
                    newValue = this.academic_year_data;
                }
                var changed = this.academic_year_data != newValue;
                this.academic_year_data = newValue;
                this.$emit('input', this.academic_year_data);
                if(changed){
                    this.$emit('change', this.academic_year_data);
                }
            },
        },
        watch: {
            /**
             * Handle changes to academic_year
             */
            academic_year_data: function() {
                this.$searchAcademicYearId = this.academic_year_data;
            },
        }
    }
</script>
